import { Button, Grid } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import FetchLogin from "../components/Fetch/FetchLogin";

export default function AgentQuestion() {
  const token = useSelector((state) => state.login.token);
  const [v, setV] = React.useState({
    refer: "0%",
    minSale: "S$0",
    maxSale: "S$0",
    minTier: "0%",
  });

  const reqAgentQuestion = FetchLogin("agent-question", {
    data: { token: token },
    callback: (cb) => {
      if (cb.response.success) {
        window.location.reload();
      }
    },
  });

  const reqAgentCms = FetchLogin("agent-cms", {
    data: { token: token },
    callback: (cb) => {
      if (cb.response.success) {
        setV2({
          refer: cb.response.data.refer,
          minSale: cb.response.data.minSale,
          maxSale: cb.response.data.maxSale,
          minTier: cb.response.data.minTier,
        });
      }
    },
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  React.useEffect(() => {
    reqAgentCms.handleTrigger();
    // eslint-disable-next-line
  }, []);

  return (
    <MainContainer
      render={
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              height: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TopBar leftSide="-1" title="Be an Agent" />
          </Grid>
        </Grid>
      }
    >
      <div
        style={{
          textAlign: "left",
          background: "transparent",
          paddingLeft: 48,
          paddingTop: 32,
          height: "80vh",
          fontSize: "1.25rem",
        }}
      >
        <h1>Get up to {v.maxSale} Bonus weekly when You Earn as an agent!</h1>
        <p>
          Hit weekly sales target and get from {v.minSale} bonus plus from{" "}
          {v.minTier + " "}
          total bet purchased, plus {v.refer} if number you Purchased strike.
        </p>
        <Button onClick={() => reqAgentQuestion.handleTrigger()}>
          Join Now
        </Button>
      </div>
    </MainContainer>
  );
}
